import React from 'react';
import { Box, Container, Link, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import siteText from '../content/siteText.json';

const Footer = () => {
    const { footer } = siteText;

    return (
        <Box
            component="footer"
            sx={{
                mt: 8,
                py: 3,
                borderTop: '1px solid rgba(250, 236, 244, 0.18)',
                backgroundColor: '#cc6f5f'
            }}
        >
            <Container
                maxWidth={false}
                sx={{
                    width: 'min(92vw, 1600px)',
                    mx: 'auto'
                }}
            >
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 1.1,
                        alignItems: 'center',
                        textAlign: 'center'
                    }}
                >
                    <Typography
                        variant="body2"
                        sx={{
                            color: 'rgba(250, 236, 244, 0.92)',
                            fontSize: '0.9rem'
                        }}
                    >
                        {footer.line1}
                    </Typography>

                    <Typography
                        variant="body2"
                        sx={{
                            color: 'rgba(250, 236, 244, 0.78)',
                            fontSize: '0.8rem'
                        }}
                    >
                        {footer.line2}
                    </Typography>

                    <Link
                        component={RouterLink}
                        to="/policies"
                        underline="hover"
                        sx={{
                            color: 'rgba(250, 236, 244, 0.88)',
                            fontSize: '0.8rem',
                            fontWeight: 500,
                            textUnderlineOffset: '3px'
                        }}
                    >
                        Privacy Policy & Technology Usage Agreement
                    </Link>

                    <Typography
                        variant="caption"
                        sx={{
                            color: 'rgba(250, 236, 244, 0.66)',
                            fontSize: '0.68rem',
                            lineHeight: 1.5
                        }}
                    >
                        Icons made from{' '}
                        <Link
                            href="https://www.onlinewebfonts.com/icon"
                            target="_blank"
                            rel="noopener noreferrer"
                            underline="hover"
                            sx={{
                                color: 'rgba(250, 236, 244, 0.82)'
                            }}
                        >
                            svg icons
                        </Link>{' '}
                        are licensed by CC BY 4.0
                    </Typography>
                </Box>
            </Container>
        </Box>
    );
};

export default Footer;